var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonagensBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 641.399,
    height: 387.671,
    viewBox: "0 0 641.399 387.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M605.45,422.19q-4.29,2.43-8.63,4.7H107.86c-23.11-25.94-40.28-67.31-48.27-95.23-10.22-35.75-3.24-77.71,23.8-103.44,19.2-18.27,45.67-26.53,68.7-39.78,30.67-17.65,55.04-44.06,79.39-69.63s49.83-51.2,81.71-66.62,71.79-18.94,101.9-.38c36.09,22.25,52.08,71.25,92.13,85.33,32.17,11.31,67.93-4.53,101.65.73,45.95,7.18,77.41,52.7,85.25,98.15C706.55,308.07,669.46,385.94,605.45,422.19Z",
    transform: "translate(-55.108 -39.219)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonagensBg);
export default __webpack_public_path__ + "static/media/PersonagensBg.4446702143065dbbd707596d469146ab.svg";
export { ForwardRef as ReactComponent };